// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__Yt_DZ","empty":"ModalGraph_empty__2ASA4"};